import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { RootState } from './redux/store';
import { stepAndRouteMap } from './constants';
import usePageLandingsEvents from './events/usePageLandingEvents';

export const RouteManager = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const accountState = useSelector((state: RootState) => state.account);
  const nextStep = accountState?.userDetails?.nextStep;
  const { TriggerPageLandingEvents } = usePageLandingsEvents();

  const handleRoute = () => {
    const { currentStep } = accountState.userDetails;
    const { pathname } = window.location;
    if (pathname === '/income-proof/callback/') {
      navigate('/income-proof/callback', { replace: true });
    } else if (currentStep === 're_verification') {
      navigate('/re-verification', { replace: true });
    } else if (
      currentStep === "verified"
      || currentStep === "verification_pending"
      || currentStep === "e_sign_completed"
    ) {
      navigate("/completed", { replace: true });
    } else if (nextStep) {
      if (nextStep === "") {
        navigate("/", { replace: true });
      } else if (stepAndRouteMap[nextStep]?.includes(pathname)) {
        navigate(stepAndRouteMap[nextStep], { replace: true });
      }
    } else {
      navigate(stepAndRouteMap[nextStep], { replace: true });
    }
  };
  useEffect(() => {
    handleRoute();
  }, [nextStep, location.pathname]);

  useEffect(() => {
    TriggerPageLandingEvents(location.pathname)
  }, [location.pathname]);

  return (
    // eslint-disable-next-line no-inline-styles/no-inline-styles
    <div style={{ display: 'none' }} />
  );
};

export default RouteManager;
